import { BROKER_PIPELINE_LOANS_URL } from './brokerPipelineApi.constants';

/**
 * Shop-level broker pipeline client (DEV-3779, Skynet.Loans behind the loans
 * gateway). GET /api/brokerPipeline/loans returns the caller's sub-company
 * subtree of active loans, server-scoped from the authenticated user (owner ->
 * whole shop, LO -> their slice), so no company/subcompany id is passed. PII is
 * minimized at the source to borrower last name + loan last-4.
 *
 * Response shape:
 *   { loans: [{ applicationId, loanNumberLast4, borrowerLastName, loanOfficerName,
 *               milestoneLabel, daysInCurrentStatus, openConditionCount,
 *               lockExpirationDate }], asOf }
 */
export class BrokerPipelineApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getBrokerPipelineLoans({ config = {} } = {}) {
    return this.#http.get(BROKER_PIPELINE_LOANS_URL, config);
  }
}
